module.exports = __webpack_public_path__ + "static/media/joyces.f90b1bf8.png";